import { ReferenceFieldPickerController } from './referenceFieldPicker.controller';

const referenceFieldPickerHtml = require('./referenceFieldPicker.html');

/* @ngInject */
export function referenceFieldPickerDirective(): ng.IDirective {
  return {
    restrict: 'E',
    scope: {
      models: '=',
      refHolder: '=',
      conditions: '=',
      referenceFieldKey: '='
    },
    controller: ReferenceFieldPickerController,
    controllerAs: 'refFieldPickerCtrl',
    templateUrl: referenceFieldPickerHtml
  };
}
